export default "__VITE_ASSET__4488745b__"